// import appConfig from 'application-config';
import _ from 'lodash';

// import { parseURL } from 'common/utils';
import { ref, getDownloadURL, uploadBytesResumable } from 'firebase/storage';
import { storage } from 'common/database/firebase-config';
import { ORIGINAL_IMAGE_IDENTIFIER } from '../../../functions/common/constants.json';

export function uploadMedia(firebase) {
	return async (file, options = {}) => {
		let originalFileName;
		let { name } = options;

		if (!name) {
			if (options.isStatic) {
				// upload static images, e.g. "share image".
				const extension = options.extension || _.last(file.name.split('.'));
				name = `static/${`${options.filename}.${extension}`}`;
			} else if (file.type.includes('video')) {
				name = `videos/${Date.now()}-${file.name}`;
			} else {
				originalFileName = file.name.replace(/\.(?!.*\.)/, `${ORIGINAL_IMAGE_IDENTIFIER}.`);
				name = `images/${Date.now()}-${originalFileName}`;
			}
		}

		const metadata = {
			contentType: file.type,
		};

		const storageRef = ref(storage, `${name}`);
		const uploadTask = uploadBytesResumable(storageRef, file, metadata);

		return new Promise((resolve, reject) => {
			uploadTask.on(
				'state_changed',
				snapshot => {
					const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
					console.info(progress);
				},
				error => {
					console.error(error);
					reject(error);
				},
				async () => {
					const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
					// const { pathname, search } = parseURL(downloadURL);
					// const fileName = _.last(pathname.split('/'));
					// const CDN_URL = `${appConfig.cdn.hostname}/${fileName}${search}`;
					resolve({
						url: downloadURL,
						name,
					});
				}
			);
		});
	};
}
